import React, { useState } from "react";
import { useIntl } from "react-intl";

import { ClickableComponent, TextFieldComponent } from "@app/core";
import { FormGroup } from "@app/core/form-group/form-group";
import { FormRow } from "@app/core/form-row/form-row";
import { FormField } from "@app/core/form-field/form-field";

import styles from "./edf-edit-bulk-form.module.scss";

export interface IEdfEditBulkSearchQueryFormProps {
  isLoading: boolean;
  onSubmit: (searchQuery: string) => void;
}

const EdfEditBulkSearchQueryForm = (props: IEdfEditBulkSearchQueryFormProps) => {
  const intl = useIntl();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const trimmedSearchQuery = searchQuery.trim();

  return (
    <form
      className={styles.form}
      onSubmit={(e) => {
        e.preventDefault();
        if (trimmedSearchQuery) {
          props.onSubmit(trimmedSearchQuery);
        }
      }}
    >
      <FormGroup>
        <FormRow>
          <FormField>
            <TextFieldComponent
              id="bulkSearchQuery"
              value={searchQuery}
              maxCharacters={255}
              onChange={(e) => setSearchQuery(e.target.value)}
              label={{
                label: intl.formatMessage({ id: "externalDealFilters.form.patchMany.searchQuery.label" })
              }}
            />
          </FormField>
        </FormRow>
      </FormGroup>

      <div className={styles.bottomBar}>
        <ClickableComponent
          buttonType="submit"
          title={intl.formatMessage({ id: "externalDealFilters.form.patchMany.searchQuery.save" })}
          height={48}
          disabled={props.isLoading || !trimmedSearchQuery}
        />
      </div>
    </form>
  );
};

export { EdfEditBulkSearchQueryForm };
